import { EmptyData } from '@admin/core/models/empty-data';
import { Injectable } from '@angular/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { UrlConfigContainer } from '@admin/core/url-config';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { Observable } from 'rxjs';
import { PagingWrapper } from '@admin/core/models/paging-wrapper';
import { PaymentListItemModel } from '../models/payment-list-item-model';
import { PaymentListFilterModel } from '../models/payment-list-filter-model';
import {
  PaymentModel,
  AccountModel,
  InvoiceModel,
} from '@admin/billing/payments/shared/models/payment-model';
import { PaymentListTotalsModel } from '@admin/billing/payments/shared/models/payment-list-totals';
import { UrlConfigService } from '@hrra/core';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}

  public listPayments(
    filter: PagingFilter<PaymentListFilterModel>
  ): Observable<PagingWrapper<PaymentListItemModel>> {
    return this.ajax.postDataPaging(
      this.urlService.urlConfig.api.data.payments.list,
      filter.toObject(),
      PaymentListItemModel
    );
  }

  public getPaymentsTotalAmounts(
    filter: PagingFilter<PaymentListFilterModel>
  ): Observable<PaymentListTotalsModel> {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.payments.totals,
      filter.toObject(),
      PaymentListTotalsModel
    );
  }

  public searchAccounts(query: string) {
    return this.ajax.getDataPaging(
      this.urlService.urlConfig.api.data.accounts.search,
      { query: query },
      AccountModel
    );
  }

  public searchInvoices(query: string, accountId: number, onlyUnpaid: boolean) {
    return this.ajax.postDataPaging(
      this.urlService.urlConfig.api.data.invoices.search,
      { query: query, accountId: accountId, onlyUnpaid: onlyUnpaid },
      InvoiceModel
    );
  }

  public getPayment(paymentId: number) {
    return this.ajax.getData(
      this.urlService.urlConfig.api.data.payments.get,
      { paymentId: paymentId },
      PaymentModel
    );
  }

  public addPayment(payment: PaymentModel) {
    let submitData = {
      AccountId: payment.payerAccount.accountId,
      Amount: payment.amount,
      PaymentDate: payment.paymentDate,
      InvoiceIds: payment.activeInvoiceCoverages.map(
        (c) => c.invoice.invoiceId
      ),
      Comment: payment.comment,
    };

    return this.ajax.postData(
      this.urlService.urlConfig.api.data.payments.add,
      submitData,
      EmptyData
    );
  }

  public editPayment(payment: PaymentModel) {
    let submitData = {
      PaymentId: payment.paymentId,
      AccountId: payment.payerAccount.accountId,
      Amount: payment.amount,
      PaymentDate: payment.paymentDate,
      InvoiceIds: payment.activeInvoiceCoverages.map(
        (c) => c.invoice.invoiceId
      ),
      Comment: payment.comment,
    };

    return this.ajax.postData(
      this.urlService.urlConfig.api.data.payments.edit,
      submitData,
      EmptyData
    );
  }

  public deletePayment(paymentId: number) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.payments.delete,
      { PaymentId: paymentId },
      EmptyData
    );
  }
}
